import React from 'react';
import { Snackbar, Box, Button, IconButton, Slide } from '@mui/material';
import { Close, CheckCircle, Error, Warning, Info } from '@mui/icons-material';

const getNotificationIcon = (severity) => {
  const iconStyle = { marginRight: '8px', fontSize: '18px' };

  switch (severity) {
    case 'success':
      return <CheckCircle sx={{ ...iconStyle, color: '#4caf50' }} />;
    case 'error':
      return <Error sx={{ ...iconStyle, color: '#f44336' }} />;
    case 'warning':
      return <Warning sx={{ ...iconStyle, color: '#ff9800' }} />;
    case 'info':
      return <Info sx={{ ...iconStyle, color: '#2196f3' }} />;
    default:
      return <Info sx={{ ...iconStyle, color: '#2196f3' }} />;
  }
};

const NotificationSnackbar = ({ snackbars = [], onClose }) => {
  const handleActionClick = (snackbar) => {
    if (typeof snackbar.onClick === 'function') {
      snackbar.onClick();
    }
    onClose(snackbar.id);
  };

  return (
    <>
      {snackbars.map((snackbar, index) => {
        const stackIndex = snackbars.length - index - 1;
        return (
        <Snackbar
          key={snackbar.id}
          open={snackbar.open}
          autoHideDuration={snackbar.duration || 6000}
          onClose={() => onClose(snackbar.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          TransitionComponent={Slide}
          TransitionProps={{ direction: 'left' }}
          sx={{
            bottom: `${24 + stackIndex * 58}px !important`
          }}
        >
          <Box
            sx={{
              background: 'rgb(54, 54, 54)',
              color: 'rgb(255, 255, 255)',
              padding: '12px 16px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              display: 'flex',
              alignItems: 'center',
              minWidth: '300px',
              maxWidth: '500px',
              animation: '0.35s cubic-bezier(0.21, 1.02, 0.73, 1) 0s 1 normal forwards running',
              '@keyframes slideIn': {
                from: { transform: 'translateX(100%)', opacity: 0 },
                to: { transform: 'translateX(0)', opacity: 1 }
              }
            }}
          >
            {getNotificationIcon(snackbar.severity)}

            <Box sx={{ flex: 1, fontSize: '14px', lineHeight: 1.4 }}>
              {snackbar.message}
            </Box>

            {snackbar.actionLabel ? (
              <Button
                size="small"
                onClick={() => handleActionClick(snackbar)}
                sx={{
                  color: 'rgb(255, 255, 255)',
                  minWidth: 'auto',
                  marginLeft: '8px',
                  textTransform: 'none',
                  whiteSpace: 'nowrap'
                }}
              >
                {snackbar.actionLabel}
              </Button>
            ) : null}

            <IconButton
              size="small"
              onClick={() => onClose(snackbar.id)}
              sx={{
                color: 'rgb(255, 255, 255)',
                marginLeft: '8px',
                padding: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              <Close sx={{ fontSize: '18px' }} />
            </IconButton>
          </Box>
        </Snackbar>
        );
      })}
    </>
  );
};

export default NotificationSnackbar;
